// extracted by mini-css-extract-plugin
export var chevron = "_3s-d";
export var disabled = "_3s-b";
export var error = "_3s-c";
export var hideBorder = "_3s-1";
export var icon = "_3s-e";
export var input = "_3s-0";
export var large = "_3s-f";
export var open = "_3s-9";
export var placeholder = "_3s-a";
export var regular = "_3s-5";
export var singleRowInput = "_3s-2";
export var singleSelectInput = "_3s-3 _3s-0";
export var small = "_3s-4";
export var spinnerContainer = "_3s-i";
export var tag = "_3s-7";
export var tagsContainer = "_3s-8";
export var tagsInput = "_3s-6 _3s-0";
export var xSmall = "_3s-g";
export var xxSmall = "_3s-h";